import React from 'react';
import { isLastElement } from 'globals/utils';
import defaultLocales from 'globals/locales/default';
import FsMediumSwitch from 'ui-elements/form-elements/FsMediumSwitch';
import { NotificationType } from 'globals/types';
import {
  Label,
  SingleSwitchBox,
  SwitchesWrapperBox,
} from './NotificationSwitches.style-elements';

const getLabel = (key: NotificationType): string => {
  switch (key) {
    case NotificationType.REPORTS:
      return defaultLocales.enums[NotificationType.REPORTS];
    case NotificationType.BANKS:
      return defaultLocales.enums[NotificationType.BANKS];
    case NotificationType.OTHERS:
      return defaultLocales.enums[NotificationType.OTHERS];
    default:
      return '';
  }
};

export interface ShowNotificationsProps {
  [NotificationType.REPORTS]: boolean;
  [NotificationType.BANKS]: boolean;
  [NotificationType.OTHERS]: boolean;
}

export interface NotificationSwitchesProps {
  showNotifications: ShowNotificationsProps;
  onSwitchesUpdate: (key: NotificationType) => void;
}

const NotificationSwitches: React.FC<NotificationSwitchesProps> = ({
  showNotifications,
  onSwitchesUpdate,
}) => {
  const switches = Object.values(NotificationType);

  return (
    <SwitchesWrapperBox>
      {switches.map((key, idx) => (
        <SingleSwitchBox key={key} isLast={isLastElement(idx, switches.length)}>
          <Label>{getLabel(key)}</Label>
          <FsMediumSwitch
            checked={showNotifications[key]}
            onChange={() => onSwitchesUpdate(key)}
          />
        </SingleSwitchBox>
      ))}
    </SwitchesWrapperBox>
  );
};

export default NotificationSwitches;
